var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FCFCFC",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M38.542 67.833c17.88 0 32.375-14.494 32.375-32.375 0-17.88-14.495-32.375-32.375-32.375-17.88 0-32.375 14.495-32.375 32.375a32.225 32.225 0 0 0 4.532 16.53L6.167 67.833l16.235-4.303a32.227 32.227 0 0 0 16.14 4.303Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.75ebac852d1cd82982c40f41c5b0347e.svg";
export { ForwardRef as ReactComponent };